'use client';

import { useRouter } from 'next/navigation';

import ErrorContent from './ErrorContent';

type Props = {
  title: string;
  description: string;
  showHomeButton?: boolean;
};

function PageError(props: Props) {
  const { title, description, showHomeButton = true } = props;
  const router = useRouter();

  const handleHomeClick = () => {
    router.push('/');
  };

  return (
    <ErrorContent
      title={title}
      description={description}
      showHomeButton={showHomeButton}
      onHomeClick={handleHomeClick}
    />
  );
}

export default PageError;
